<template>
	<div>
		<div class="timeline-3_row">
			<div class="timeline-3_col-1">{{ match.event_name }}</div>
			<div class="timeline-3_col-2">Стрельба</div>
			<div class="timeline-3_col-3">Время</div>
			<div class="timeline-3_col-4">Место</div>
		</div>
		<div class="timeline-3_row" v-for="participant in match.participants" :key="participant.id">
			<div class="timeline-3_col-1">
				<img :src="$hostname + participant.image_ref" alt="">
				<span>{{ participant.name }}</span>
			</div>
			<div class="timeline-3_col-2">{{ participant.missed_shots }}</div>
			<div class="timeline-3_col-3">{{ participant.duration }}</div>
			<div class="timeline-3_col-4">{{ participant.rank }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['match']
	}
</script>